import { actionCreatorFactory, Action } from "typescript-fsa";
import { isType } from "typescript-fsa";

const actionCreator = actionCreatorFactory("VISIT_API");

interface HelperParams<S, E extends Error> {
  /**
   * Path string which will be prefixed by wantedly hostname
   */
  path: string;
  /**
   * Shortcut params to build url query
   */
  query?: {};

  /**
   * For private use
   */
  response?: S & never;

  /**
   * For private use
   */
  failure?: E & never;

  /**
   * This is used to determine a action is a request action.
   */
  $type?: "VISIT_API";

  body?: object | RequestInit["body"];
}

export type RequestParams<S, E extends Error> = HelperParams<S, E> &
  Omit<RequestInit, keyof HelperParams<S, E> & keyof RequestInit>;

interface VisitApiHeaders {
  "X-List-CurrentPage": number;
  "X-List-TotalCount"?: number;
  "X-List-NumPages"?: number;
  "X-List-IsFisrtPage"?: boolean;
  "X-List-IsLastPage"?: boolean;
}

export interface Response {
  status: number;
  statusText: string;
  headers: VisitApiHeaders;
}

export interface Success<S> extends Response {
  body: S;
  isSuccess: true;
}
export interface Failure<E extends Error> extends Response {
  body: E;
  isFailure: true;
}
export type AnyResponse = Success<any> | Failure<any>;
export type AnyResponseAction = Action<Success<any>> | Action<Failure<any>>;

export const succeeded = actionCreator<Success<any>>("SUCCEEDED", undefined, false);
export const failed = actionCreator<Failure<any>>("FAILED", undefined, true);

export function isSuccess<S, E extends Error>(
  action: Action<Success<S>> | Action<Failure<E>>
): action is Action<Success<S>> {
  return isType(action, succeeded);
}

export function isFailure<S, E extends Error>(
  action: Action<Success<S>> | Action<Failure<E>>
): action is Action<Failure<E>> {
  return isType(action, failed);
}

export interface RequestCreator<S, E extends Error, P> {
  // tslint:disable-next-line:callable-types
  (params: P): RequestParams<S, E>;
}

export function requestCreator<P, S, E extends Error>(
  func: (params: P) => RequestParams<S, E>
): RequestCreator<S, E, P> {
  return (params: P) => {
    const req = func(params);
    req.$type = "VISIT_API";
    return req;
  };
}

export class UnknownError extends Error {
  constructor(message: string) {
    super(message);
  }
}

export interface PageParams {
  page: number;
  perPage: number;
}



// WEBPACK FOOTER //
// ./frontend/src/common/actions/VisitApi.ts